export default __webpack_public_path__ + "static/media/future.be1c4001.jpg";